// extracted by mini-css-extract-plugin
export var chip = "_cn-0";
export var filterDropdown = "_cn-5";
export var filterItem = "_cn-6";
export var icon = "_cn-1";
export var removeButton = "_cn-3";
export var removeIcon = "_cn-4";
export var separator = "_cn-2";